const USER_STATS_CACHE_PREFIX = 'zodiacus_userStats_cache_v1:';
const GAMI_CACHE_PREFIX = 'zodiacus_gami_cache_v1:';

function userStatsKey(uid) {
  const u = (uid && String(uid)) ? String(uid) : 'anon';
  return USER_STATS_CACHE_PREFIX + u;
}

function gamiKey(uid) {
  const u = (uid && String(uid)) ? String(uid) : 'anon';
  return GAMI_CACHE_PREFIX + u;
}

export function _loadUserStatsCache(uid) {
  try { return JSON.parse(localStorage.getItem(userStatsKey(uid)) || 'null'); } catch { return null; }
}

export function _saveUserStatsCache(uid, obj) {
  try { localStorage.setItem(userStatsKey(uid), JSON.stringify(obj)); } catch {}
}

export function _loadGamiCache(uid) {
  try { return JSON.parse(localStorage.getItem(gamiKey(uid)) || 'null'); } catch { return null; }
}

export function _saveGamiCache(uid, obj) {
  try { localStorage.setItem(gamiKey(uid), JSON.stringify(obj)); } catch {}
}
